// extracted by mini-css-extract-plugin
module.exports = {"container":"fittingInstructions_container__1Efc0"};